import React from "react";

type CoverPDFProps = {
  title?: string;
  intro?: string;
  firstPublish?: string;
  sisteFagligeEndring?: string;
};

export default function CoverPDF({
  title,
  firstPublish,
  sisteFagligeEndring
}: Readonly<CoverPDFProps>) {
  return (
    <table className="mt-[40px] w-full border-0 border-separate print-page-break">
      <tbody>
        <tr>
          <td className="w-full space-y-4">
            {title ? <h1>{title}</h1> : null}

            <hr />

            <p>
              {firstPublish ? (
                <span className="block">{`Først publisert: ${firstPublish}`}</span>
              ) : null}

              {sisteFagligeEndring ? (
                <span className="block">{`Siste faglige endring: ${sisteFagligeEndring}`}</span>
              ) : null}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
